'use es6';

import { Map as ImmutableMap, Record } from 'immutable';
const METRICS = ImmutableMap([[0, 'submissionsPerPageview']]);
const DEFAULTS = {
  deletedAt: 0,
  id: 0,
  metric: METRICS.first(),
  startedAt: 0
};
export default class MABExperiment extends Record(DEFAULTS) {
  static fromJS({
    deletedAt,
    id,
    metricId,
    startedAt
  }) {
    return new MABExperiment({
      deletedAt,
      id,
      metric: METRICS.get(metricId),
      startedAt
    });
  }

}